<template>
  <div class="collectpopup" v-if="dataVal.flag">
    <div class="collect">
      <div class="collect_head">
        <div class="collect_head_close"></div>
        <div class="collect_head_title">收藏信息</div>
        <div class="collect_head_close" @click="handleRefund">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="collect_info">
        <div class="collect_info_item">
          <div class="collect_info_item_l">中文方案名称：</div>
          <div class="collect_info_item_r1">
            <el-input v-model="collectobj.title" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="collect_info_item">
          <div class="collect_info_item_l">英文方案名称：</div>
          <div class="collect_info_item_r1">
            <el-input v-model="collectobj.title_en" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="collect_info_item" v-if="type == 'edit'">
          <div class="collect_info_item_l">排序：</div>
          <div class="collect_info_item_r1">
            <el-input v-model="collectobj.orderlist" placeholder="请输入内容" type="number"></el-input>
          </div>
        </div>
        <div class="collect_info_item">
          <div class="collect_info_item_l">中文方案描述：</div>
          <div class="collect_info_item_r2">
            <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="collectobj.describe">
            </el-input>
          </div>
        </div>
        <div class="collect_info_item">
          <div class="collect_info_item_l">英文方案描述：</div>
          <div class="collect_info_item_r2">
            <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="collectobj.describe_en">
            </el-input>
          </div>
        </div>
        <div class="collect_info_item">
          <div class="collect_info_item_l">缩略图：</div>
          <div class="collect_info_item_r3">
            <div class="collect_info_item_r_tip" v-if="urlarr.length == 0">
              <i class="el-icon-download"></i>
              <span>上传图片</span>
            </div>
            <img :src="urls + urlarr[0]" alt="" v-if="urlarr.length > 0" srcset="" />
            <div class="cen_body_mtr_img_unload">
              <el-upload class="avatar-uploader" :action="uploadfile" :headers="headers"
                accept="image/jpg,image/jpeg,image/png" :file-list="imageslist" :show-file-list="true"
                :on-success="handleAvatarSuccess" :on-progress="handleUploadProgress">
                <img class="avatar" />
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div class="cen_body_mtr_img_pro" v-if="imageslist.length > 0 && percentage && percentage != 100">
              <el-progress type="circle" :percentage="percentage"></el-progress>
            </div>
            <div class="cen_body_mtr_img_close" v-if="urlarr[0]" @click="
              imageslist = [];
            urlarr = [];
            ">
              <i class="el-icon-close" style="color: #fff"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="collect_btn">
        <div class="collect_btn_cancel" @click="handleRefund">取消</div>
        <div class="collect_btn_cancel collect_btn_submit" @click="handleSubmit">
          提交
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "collect",
  props: ["dataVal"],
  data() {
    return {
      uploadfile: localStorage.getItem("baseURL") + "/api/admin/index/uploadfile",

      imageslist: [],
      urlarr: [],
      headers: {
        token: localStorage.token,
      },
      imguploagsuccess: false, //是否处于上传图片中
      percentage: 0,

      collectobj: {
        scheme_id: "",
        title: "",
        thumbnail: "",
        describe: "",
        orderlist: "",
        id: "",
        title_en: "",
        describe_en: "",
        area: 1
      },
      urls: localStorage.getItem('baseURL'),
      type: ""
    };
  },
  methods: {
    //取消弹窗
    handleRefund() {
      let data = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("collectCall", data);
    },
    async handleSubmit() {
      this.collectobj.thumbnail = this.urlarr[0];
      if (this.type == "edit") {
        this.collectobj.id = this.collectobj.scheme_id;
        let res = await this.$api.indexEditcollect({
          ...this.collectobj,
        });
        if (res.code == 1) {
          this.$message.success(res.msg);
          let obj = {
            flag: false, //弹窗是否显示
            submitFlag: true, //是否调用接口
            data: this.collectobj,
          };
          this.$emit("collectCall", obj);
        }
      } else {
        let res = await this.$api.indexSetcollect({
          ...this.collectobj,
        });
        if (res.code == 1) {
          this.$message.success(res.msg);
          let obj = {
            flag: false, //弹窗是否显示
            submitFlag: true, //是否调用接口
            data: this.collectobj,
          };
          this.$emit("collectCall", obj);
        }
      }
    },
    handleUploadProgress(event, file, fileList) {
      this.imguploagsuccess = true;
      let filearr = fileList;
      filearr[0].percentage = Math.round(Number(event.percent));
      this.imageslist = filearr;
      this.percentage = Math.round(Number(event.percent));
      console.log(fileList, filearr, this.imageslist, event.percent);
    },
    beforeAvatarSuccess(file) {
      var img = file.name.substring(file.name.lastIndexOf(".") + 1);
      const suffix = img === "jpg" || "JPG";
      const suffix2 = img === "png" || "PNG";
      const suffix3 = img === "jpeg" || "JPEG";
      // const isLt35M = file.size / 1024 / 1024 < 20; // 限制为小于35MB
      if (!suffix && !suffix2 && !suffix3) {
        this.$message.error("只能上传图片！");
        return false;
      }

      return suffix || suffix2 || suffix3;
    },
    //图片上传
    handleAvatarSuccess(response, file, fileList) {
      this.imguploagsuccess = false;
      if (response.code == 1) {
        this.urlarr = [];
        this.urlarr.push(response.data.file);
        fileList.forEach((element, i) => {
          if (element.response && element.response.code == 0) {
            fileList.splice(i, 1);
          }
        });
        this.imageslist = fileList;
        this.imageslist[0].url = this.urlarr[0];

        console.log(this.imageslist, this.urlarr);
        this.$message({
          type: "success",
          message: "图片上传成功",
        });
      } else {
        fileList.forEach((element, i) => {
          if (element.response && element.response.code == 0) {
            fileList.splice(i, 1);
          }
        });
        this.imageslist = fileList;
        this.$message({
          type: "success",
          message: response.msg,
        });
      }
    },
  },
  watch: {
    dataVal: {
      handler(newValue, oldValue) {
        if (newValue.data.collect) {
          this.collectobj.scheme_id = newValue.data.id;
          this.collectobj.title = newValue.data.collect.title;
          this.collectobj.describe = newValue.data.collect.describe;
          this.collectobj.title_en = newValue.data.collect.title_en;
          this.collectobj.describe_en = newValue.data.collect.describe_en;
          this.collectobj.thumbnail = newValue.data.collect.thumbnail;
          this.collectobj.orderlist = newValue.data.orderlist;
          this.collectobj.area = newValue.data.collect.area;
          this.type = newValue.type;
          this.urlarr = [];
          if (newValue.data.collect.thumbnail) {
            this.urlarr.push(newValue.data.collect.thumbnail);
          }
        } else {
          this.collectobj.scheme_id = "";
          this.collectobj.id = "";
          this.collectobj.title = "";
          this.collectobj.describe = "";
          this.collectobj.thumbnail = "";
          this.collectobj.orderlist = "";
          this.collectobj.title_en = "";
          this.collectobj.describe_en = "";
          this.collectobj.area = 1;
          this.urlarr = [];
        }
        console.log('this.collectobj', this.collectobj)
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.collectpopup {
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;

  .collect {
    min-width: 540px;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .collect_head {
      width: 100%;
      height: 50px;
      background-color: #f6f6f6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .collect_head_close {
        width: 20px;
        height: 20px;
        cursor: pointer;

        .el-icon-close {
          font-size: 20px;
          color: #999999;
          cursor: pointer;
        }
      }

      .collect_head_title {
        font-size: 16px;
        color: #333333;
        cursor: default;
      }
    }

    .collect_info {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 0 37px 0 29px;
      margin-top: 10px;

      .collect_info_item {
        width: 100%;
        display: flex;
        margin-top: 20px;

        .collect_info_item_l {
          width: 120px;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          letter-spacing: 1px;
          color: #333333;
          text-align: right;
          padding-right: 10px;
        }

        .collect_info_item_r1 {
          width: 400px;
        }

        .collect_info_item_r2 {
          width: 400px;
        }

        .collect_info_item_r3 {
          width: 400px;
          height: 200px;
          background-color: #f9f9f9;
          border-radius: 4px;
          border: solid 1px #dbdbdb;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 101;

          img {
            max-width: 100%;
            max-height: 100%;
          }

          .collect_info_item_r_tip {
            display: flex;
            align-items: center;

            .el-icon-download {
              font-size: 16px;
              color: #999999;
            }

            span {
              font-size: 14px;
              color: #999999;
              margin-left: 10px;
            }
          }

          .cen_body_mtr_img_unload {
            width: 100%;
            height: 100%;
            opacity: 0;
            position: absolute;
            z-index: 102;

            /deep/.avatar-uploader {
              width: 100%;
              height: 100%;

              .el-upload {
                width: 100%;
                height: 100%;
              }
            }
          }

          .cen_body_mtr_img_pro {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 103;

            /deep/.el-progress {
              width: 108px;
              height: 108px;
              padding: 10px;

              .el-progress-circle {
                width: 100% !important;
                height: 100% !important;
              }
            }
          }

          .cen_body_mtr_img_close {
            width: 20px;
            height: 20px;
            background-color: #000;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 104;
            cursor: pointer;

            .el-icon-close {
              font-size: 16px;
            }
          }
        }
      }
    }

    .collect_btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 30px 37px 26px 37px;

      .collect_btn_cancel {
        width: 80px;
        height: 32px;
        font-size: 14px;
        color: #606266;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #dbdbdb;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        cursor: pointer;
      }

      .collect_btn_submit {
        color: #ffffff;
        border: solid 1px #e64a19;
        background-color: #e64a19;
      }
    }
  }
}
</style>